"use client";

import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import styles from "./OrSeparator.module.css";

export default function OrSeparator() {
  const T = useT();

  return <span className={styles.separator}>{T(TKey.OR)}</span>;
}
